<template>
  <md-card style="z-index: 0">
    <md-card-content>
      <h3>Images</h3>

      <md-progress-bar
        v-if="loading"
        md-mode="indeterminate"
      />

      <div
        v-else
        class="field-line"
      >
        <md-field>
          <label>Icon URL</label>
          <md-input v-model="images.iconImgUrl" />
        </md-field>
        <img :src="images.iconImgUrl">
      </div>

      <div class="field-line">
        <md-field>
          <label>Background Image URL</label>
          <md-input v-model="images.bgImgUrl" />
        </md-field>
        <img :src="images.bgImgUrl">
      </div>

      <md-field>
        <label>Background color</label>
        <md-input
          v-model="color"
          @change="onColorUpdate"
        />
      </md-field>
    </md-card-content>
  </md-card>
</template>
<script>
    export default {
        props: {
            images: { type: Object, required: true },
            background_color: { type: String, default: "" },
            loading: Boolean
        },
        data() {
            return {
                color: this.$props["background_color"]
            };
        },
        watch: {
            background_color() {
                if (this.$props.background_color !== this.color) {
                    this.color = this.$props.background_color;
                }
            }
        },
        methods: {
            onColorUpdate() {
                if (this.$props.background_color !== this.color) {
                    this.$emit("update:background_color", this.color);
                }
            }
        }
    };
</script>
<style scoped lang="scss">
    .field-line {
        display: flex;

        img {
            margin: auto 0 auto 15px;
            background-color: #222;
            width: 35px;
            height: 35px;
        }
    }
</style>
